export const DOCUMENTS_PATH = 'documents'
export const EDGES_PATH = 'edges'
export const NODE_PATH = 'node'
export const NODES_PATH = 'nodes'
